import { Badge } from '@sweep-io/sweep-design';
import type { SingleSelectFilterPopoverOption } from './SingleSelectFilterPopover';
import { translateTypeToHumanName } from '../../../documentation/helpers';

export const OPTION_ALL = {
  value: 'all',
  label: 'All',
};

export const getTypeOptionsWithCounter = (
  typeOptions: SingleSelectFilterPopoverOption[],
  renderLabel: (option: SingleSelectFilterPopoverOption) => number,
) => {
  return typeOptions.map((type: any) => {
    if (type.value === OPTION_ALL.value) {
      return type;
    }

    return {
      ...type,
      label: translateTypeToHumanName(type.value),
      addon: <Badge variant="secondary" label={renderLabel(type)} showZero />,
    };
  });
};
